import { Box, Popover, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import { FiFilter } from 'react-icons/fi';
import ProductFilter from './ProductFilter';
import { IconButton } from '../styles';
import { FONT_STYLE } from '../variables';

const ProductFilterPopover = ({ availableFilters, activeFilters, setPage }) => {
  const filterRef = useRef(null);

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <Box>
      <IconButton
        startIcon={<FiFilter size={18} />}
        onClick={() => setIsPopoverOpen(true)}
        title='Filtrar'
        ref={filterRef}
      >
        <Typography
          variant='small'
          sx={{
            fontWeight: FONT_STYLE.bold,
            marginLeft: 1,
          }}
        >
          Filtrar
        </Typography>
      </IconButton>

      <Popover
        open={isPopoverOpen}
        anchorEl={filterRef.current}
        onClose={() => setIsPopoverOpen(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ overflowY: 'scroll' }}
        PaperProps={{
          style: { maxHeight: '60%' },
        }}
      >
        <Box>
          {availableFilters.map((filter) => (
            <ProductFilter
              key={filter.id}
              type={filter.id}
              filter={filter}
              activeFilters={activeFilters}
              setPage={setPage}
            />
          ))}
        </Box>
      </Popover>
    </Box>
  );
};

export default ProductFilterPopover;
